import DashboardIncidentAgencyBreakdownCard from './DashboardIncidentAgencyBreakdownCard';

export default DashboardIncidentAgencyBreakdownCard;
